// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import * as React from 'react'
import computeData from '../hoc/computeData'
import { validate } from 'frame/core/formValidate'
import { mClient, abroadClient, operatorClient } from 'frame/net/clientFactory'

import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import $ from 'jquery'
import { toast, loading } from 'frame/ui/popup'
import { getPageInfo } from '../../pageInfo'
import './FormRichText.css'
import { compressImg } from '../util/compressImg'
import * as browserEnv from 'frame/core/browserEnv'

let Delta = require('quill-delta')

type Props = BasicProps & {
  field: string,
  api: string,
  style: { [string]: string },
  richStyle: string,
  placeholder: string,
  height?: string,
  isMust: boolean,
  isMultiple?: boolean,
  isCompress: boolean,
  rate?: string,
  client?: 'mclient' | 'backend' | 'backendRequireLogin' | 'abroadClient',
  isNoBorder: boolean,
  formValues: { [string]: string },
  setFormValues: ({ [key: string]: any }) => void
};

@computeData()
export default class FormRichText extends React.PureComponent<Props> {
  quill: any;
  inputFile: any;

  constructor (props: Props) {
    super(props)
    const { richStyle } = this.props
    if (richStyle === 'selfToolBar') this.modules.toolbar.container = []
  }

  static schema: PropsSchema = [
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      key: 'placeholder',
      title: '占位内容',
      type: 'text'
    },
    {
      key: 'richStyle',
      title: '选择样式',
      type: 'select',
      options: [['default', '默认'], ['selfToolBar', '自定义上传图片']],
      defaultValue: 'default'
    },
    {
      key: 'api',
      title: '上传图片地址(postFormData,参数file,返回值data)',
      type: 'textarea',
      defaultValue: '/v2/common/uploadFile'
    },
    {
      type: 'select',
      key: 'client',
      title: '类型',
      options: [
        ['mclient', 'M 站 API'],
        ['backend', '后端 API'],
        ['backendRequireLogin', '后端 (必须登录)'],
        ['abroadClient', '海外 API'],
        ['operatorClient', '运营商 API']
      ],
      defaultValue: 'mclient'
    },
    {
      key: 'height',
      title: '高度',
      type: 'text',
      defaultValue: '200'
    },
    {
      type: 'boolean',
      key: 'isNoBorder',
      title: '无边框'
    },
    {
      type: 'boolean',
      key: 'isMust',
      title: '是否必填'
    },
    {
      type: 'boolean',
      key: 'isCompress',
      title: '是否压缩图片(>200k)'
    },
    {
      type: 'text',
      key: 'rate',
      title: '压缩比',
      defaultValue: '0.1',
      visible: p => p.isCompress
    },
    {
      type: 'boolean',
      key: 'isMultiple',
      title: '图片是否多选'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '改变',
      event: 'onChange'
    },
    {
      type: 'event',
      title: '校验成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '校验失败',
      event: 'reject'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '数据校验',
      name: 'validate'
    },
    {
      title: '上传图片',
      name: 'upLoadImg'
    }
  ];

  componentDidMount () {
    this.setStyle()
    //
    const { richStyle } = this.props
    if (richStyle === 'selfToolBar') $('.ql-toolbar').hide()
  }
  setStyle = () => {
    let { height, isNoBorder } = this.props
    if (height) {
      if (!height.indexOf('px')) {
        height = `${height}px`
      }
      $('.ql-container').css({ height: height })
    }
    if (isNoBorder) {
      $('.ql-container').css({ border: 'none' })
    }
  };
  componentDidUpdate (preProps: Props) {
    let { callActions } = this.props
    if (this.getFieldValue(preProps) !== this.getFieldValue()) {
      callActions('onChange', this.getFieldValue())
    }
    this.setStyle()
  }

  getFieldValue = (props?: Props): string => {
    const { field, formValues } = props || this.props
    return formValues[field] == null ? '' : formValues[field]
  };

  actionValidate = () => {
    const { callActions, isMust } = this.props
    const fieldValue = this.getFieldValue()
    if (isMust) {
      const error = validate(fieldValue, [
        { type: 'required', message: '请输入内容' }
      ])
      if (!error.success) {
        callActions('reject', error)
      } else {
        callActions('resolve')
      }
    } else {
      callActions('resolve')
    }
  };

  actionUpLoadImg = () => {
    this.modules.toolbar.handlers.image()
  };

  onChange = (value: any) => {
    let { field, setFormValues } = this.props
    const html: string = value
    setFormValues({ [field]: html })
  };

  onFileChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    let { isCompress, rate } = this.props
    let files = e.target.files
    for (let i = 0; i < files.length; i++) {
      let file = files[i]
      if (!file) return
      if (file.size < 200 * 1024) {
        isCompress = false
      }
      loading(
        new Promise(resolve => {
          if (isCompress) {
            compressImg(file, rate).then(imgFile => {
              this.upLoadImg(imgFile)
            })
          } else {
            this.upLoadImg(file)
          }
        })
      )
    }
    this.inputFile.value = '' // 清除选择文件
    // 重新绑定
    this.inputFile.onchange = e => {
      this.onFileChange(e)
    }
  };

  modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        [{ size: ['small', false, 'large'] }],
        [{ align: [] }],
        ['image']
      ],
      handlers: {
        image: () => {
          this.inputFile.click()
        }
      }
    }
  };
  upLoadImg = (imgFile: { blob: Blob, fileName: string } | File) => {
    let editor = this.quill.editor
    let { api, client } = this.props
    let params = {
      marketplace: getPageInfo().marketplace,
      file: imgFile,
      path: ''
    }
    let apiClient = mClient
    if (client === 'abroadClient') {
      apiClient = abroadClient
    } else if (client === 'operatorClient') {
      apiClient = operatorClient
    }
    if (client === 'backend' || client === 'backendRequireLogin') {
      params.path = api
      api = `/v2/common/backendPostFormData${
        client === 'backendRequireLogin' ? 'RequireLogin' : ''
      }`
    }
    loading(apiClient.postFormData(api, params))
      .then(data => {
        let range = editor.getSelection(true)
        editor.updateContents(
          new Delta()
            .retain(range.index)
            .delete(range.length)
            .insert({ image: data.data }),
          'user'
        )
        editor.setSelection(range.index + 1, 'silent')
      })
      .catch(e => {
        toast(e.message)
      })
  };
  render () {
    if (!this.props.visible) {
      return null
    }
    const { style, placeholder, isMultiple, richStyle } = this.props
    let _isMultiple = isMultiple
    if (browserEnv.isInIOS()) {
      _isMultiple =
        isMultiple && browserEnv.getAppVersion() >= '3.1.3'
          ? isMultiple
          : false
    }
    return (
      <div className={richStyle === 'selfToolBar' ? 'ql-selfDefine' : ''}>
        <div>
          <input
            ref={ref => (this.inputFile = ref)}
            type='file'
            multiple={_isMultiple ? 'multiple' : ''}
            style={{ display: 'none' }}
            accept='image/*'
            onChange={e => {
              this.onFileChange(e)
            }}
          />
        </div>
        <ReactQuill
          style={style}
          ref={ref => (this.quill = ref)}
          value={this.getFieldValue()}
          placeholder={placeholder}
          modules={this.modules}
          onChange={this.onChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormRichText.js